import { render, staticRenderFns } from "./VerifyEmailInception.vue?vue&type=template&id=96beb64e&scoped=true"
import script from "./VerifyEmailInception.vue?vue&type=script&lang=ts"
export * from "./VerifyEmailInception.vue?vue&type=script&lang=ts"
import style0 from "./VerifyEmailInception.vue?vue&type=style&index=0&id=96beb64e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96beb64e",
  null
  
)

export default component.exports